import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { Row } from 'react-bootstrap';

import { notificador, proveedorNotificador } from '../../security/constantsRols';
import { checkRol } from '../../security';
import { getAllBusinessUnits, getProvider, getAllOperations } from '../../services/yclickMaster';
import ContractAlert from '../ContractAlert/ContractAlert';

import useProviderForm from './useProviderForm';
import HeaderProviderForm from './HeaderProviderForm';
import SelectProviderForm from './SelectProviderForm';

const ProviderAutomaticContainer = (props) => {
  const { disabled, providerField, providerValue } = props;
  const { values, errors, touched, setFieldValue, setFieldTouched } = useFormikContext();
  const [notificationArray, setNotificationArray] = useState([]);

  const {
    businessUnit,
    contractArray,
    businessUnitSwitch,
    switchInputChange,
    setBusinessUnitList,
    fetchProviders,
    fetchContract,
    setContractArray,
    fetchNotification,
    fetchAlerts
  } = useProviderForm({
    providerValue: providerValue?.providers,
    providerField: `${providerField}.providers`,
    setNotificationArray,
    replyRequest: false,
    editRequest: false,
    requestValue: false,
    requestDetails: false,
    createASDS: true
  });

  const onChangeSwitch = () => {
    setFieldValue('provider.moreBusinessUnits', !values.provider.moreBusinessUnits);
    switchInputChange();
  };

  const onChangeProvider = (val) => {
    if (val !== null) {
      if (val?.id !== values.provider.providers[0]?.provider?.id) {
        setFieldValue('provider.providers[0].provider', val);
        setFieldTouched('provider.providers[0].provider');
        fetchContract(
          providerValue?.providers[0]?.businessUnit?.id || values.ubication.uunn?.id,
          null,
          val?.id
        );
      }
      if (values.provider.providers[0]?.contract) {
        setFieldTouched('provider.providers[0].contract');
      }
      setFieldValue('provider.providers[0].contract', null);
      if (values.provider.providers[0]?.notificate) {
        setFieldTouched('provider.providers[0].notificate');
      }
      setFieldValue('provider.providers[0].notificate', null);
    } else {
      setFieldValue('provider.providers[0].provider', null);
      setFieldValue('provider.providers[0].contract', null);
      setFieldValue('provider.providers[0].notificate', null);
    }
  };

  useEffect(() => {
    if (checkRol(proveedorNotificador)) {
      getProvider().then((data) => {
        const { id, nombre } = data;

        const newData = { id, nombre, label: nombre, value: id };

        setFieldValue(`provider.providers[0].provider`, newData);
      });
    }

    if (!disabled) {
      if (values.isOyM) getAllOperations().then(setBusinessUnitList);
      else getAllBusinessUnits().then(setBusinessUnitList);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.isOyM, disabled]);

  useEffect(() => {
    setFieldValue(`provider.providers[0].businessUnit`, values.ubication?.uunn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.ubication?.uunn]);

  useEffect(() => {
    const [providerValueArray] = providerValue?.providers || [];

    if (providerValueArray) {
      if (checkRol(proveedorNotificador) && !disabled) {
        fetchContract(
          providerValueArray?.businessUnit?.id || values.ubication.uunn?.id,
          null,
          providerValueArray?.provider?.id
        );
      }
      if (
        disabled &&
        (providerValueArray?.businessUnit ||
          providerValueArray?.provider ||
          providerValueArray?.contract ||
          providerValueArray?.notificate)
      ) {
        setFieldValue(`provider.providers[${0}].businessUnit`, null);
        if (checkRol(notificador)) setFieldValue(`provider.providers[${0}].provider`, null);
        setFieldValue(`provider.providers[${0}].contract`, null);
        setFieldValue(`provider.providers[${0}].notificate`, null);

        setContractArray([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled]);

  const handleChangeUunn = (val, index) => {
    if (val?.id !== values.provider?.providers[index]?.businessUnit?.id) {
      setFieldValue(`provider.providers[${index}].businessUnit`, val);
    }
    if (values.provider?.providers[index]?.provider) {
      setFieldTouched(`provider.providers[${index}].provider`);
    }
    if (checkRol(notificador)) {
      setFieldValue(`provider.providers[${index}].provider`, null);
    }
    if (values.provider?.providers[index]?.contract) {
      setFieldTouched(`provider.providers[${index}].contract`);
    }
    setFieldValue(`provider.providers[${index}].contract`, null);
    if (values.provider?.providers[index]?.notificate) {
      setFieldTouched(`provider.providers[${index}].notificate`);
    }
    setFieldValue(`provider.providers[${index}].notificate`, null);
  };

  const handleChangeSelectContract = (val, index) => {
    if (val?.id !== values.provider?.providers[index]?.contract?.id) {
      setFieldValue(`provider.providers[${index}].contract`, val);
    }
    if (values.provider?.providers[index]?.notificate) {
      setFieldTouched(`provider.providers[${index}].notificate`);
    }
    setFieldValue(`provider.providers[${index}].notificate`, null);
    if (!values.isOyM) {
      fetchAlerts(val.nombre, index);
      fetchNotification(undefined, undefined, index);
    }
  };

  return (
    <>
      <Row>
        <HeaderProviderForm
          businessUnitSwitch={businessUnitSwitch}
          createASDS
          disabled={disabled}
          label={<strong>Proveedor</strong>}
          onChangeSwitch={onChangeSwitch}
        />
      </Row>
      <hr />
      {providerValue?.providers?.map((providerForm, index) => (
        <Row className="mt-3" key={`${providerForm?.provider?.id}-provider`}>
          <SelectProviderForm
            businessUnitSwitch={businessUnitSwitch}
            selectContract={{
              customLabel: providerForm?.alert?.alert && (
                <ContractAlert message={providerForm?.alert?.message} />
              ),
              errors: undefined,
              isDisabled:
                disabled ||
                (businessUnitSwitch &&
                  (!values.provider.providers[index].businessUnit ||
                    !values.provider.providers[index].provider)) ||
                (!businessUnitSwitch && !values.provider.providers[index].provider),

              isInvalid: undefined,
              name: `provider.providers[${index}].contract`,
              onChange: (val) => handleChangeSelectContract(val, index),
              options: contractArray?.filter((__, indexContract) => indexContract === index)[0]
                ?.contracts,
              value: values.provider.providers[index].contract,
              availableAmount: providerForm?.alert?.availableAmount
            }}
            selectNotificate={{
              isDisabled: true,
              name: `provider.providers[${index}].notificate`,
              onChange: (val) => setFieldValue(`provider.providers[${index}].notificate`, val),
              options: notificationArray,
              value: values.provider?.providers[index]?.notificate
            }}
            selectProvider={{
              errors: undefined,
              fetchData: (value) =>
                fetchProviders(value, providerValue.providers[index]?.businessUnit?.id, null),
              isDisabled: disabled || checkRol(proveedorNotificador),
              isInvalid: undefined,
              name: `provider.providers[${index}].provider`,
              onChange: checkRol(notificador) ? onChangeProvider : () => {},
              value: values.provider?.providers[index]?.provider
            }}
            selectUunn={{
              errors: errors?.provider?.providers[index]?.businessUnit,
              isDisabled: disabled,
              isInvalid: !!(
                errors?.provider?.providers[index]?.businessUnit &&
                touched?.provider?.providers[index]?.businessUnit
              ),
              name: `provider.providers[${index}].businessUnit`,
              onChange: (val) => handleChangeUunn(val, index),
              options: businessUnit,
              value: values.provider?.providers[index]?.businessUnit
            }}
            showNotify={!values.isOyM}
          />
        </Row>
      ))}

      <Row />
    </>
  );
};

ProviderAutomaticContainer.propTypes = {
  disabled: PropTypes.bool.isRequired,
  providerValue: PropTypes.shape({
    moreBusinessUnits: PropTypes.bool,
    providers: PropTypes.arrayOf(
      PropTypes.shape({
        businessUnit: PropTypes.objectOf(
          PropTypes.shape({
            id: PropTypes.number,
            label: PropTypes.string,
            nombre: PropTypes.string,
            value: PropTypes.number
          })
        ),
        provider: PropTypes.objectOf(
          PropTypes.shape({
            id: PropTypes.number,
            label: PropTypes.string,
            nombre: PropTypes.string,
            value: PropTypes.number
          })
        ),
        notificate: PropTypes.objectOf(
          PropTypes.shape({
            id: PropTypes.number,
            label: PropTypes.string,
            nombre: PropTypes.string,
            value: PropTypes.number
          })
        ),
        contract: PropTypes.objectOf(
          PropTypes.shape({
            id: PropTypes.number,
            inspectoresIds: PropTypes.arrayOf({}),
            label: PropTypes.string,
            requiereAceptacion: PropTypes.bool,
            requiereSolicitud: PropTypes.bool,
            requiereAdjuntarArchivo: PropTypes.bool,
            nombre: PropTypes.string,
            moneda: PropTypes.string,
            value: PropTypes.number
          })
        )
      })
    )
  }).isRequired,
  providerField: PropTypes.string.isRequired
};

export default ProviderAutomaticContainer;
